import { $el } from '../elements';
import { UIClassesSpec } from '../types';
import { UIView, UIViewAddSpec, UIViewSpec } from '../view';

export interface UILabeledOptions {
    above?: UIViewAddSpec;
    above_right?: UIViewAddSpec;
    before?: UIViewAddSpec;
    below?: UIViewAddSpec;
    classes?: UIClassesSpec;

    centered?: boolean;
    end?: boolean;
    required?: boolean;
}

export class UILabeled extends UIView {
    constructor(input: UIViewSpec, options: UILabeledOptions) {
        super('div', ['ui-labeled i-input', options.classes]);
        input.ui_visible_proxy = this;
        if(options.before) {
            this.classList.add('m-horizontal');
            if(options.end)
                this.classList.add('m-end');
            if(options.centered)
                this.classList.add('m-centered');
            this.ui_add([$el.DIV(['r-label r-before'], [options.before, options.required && $el.REQUIRED()]), input]);
        } else {
            this.classList.add('m-vertical');

            let above: UIViewSpec | undefined;
            if(options.above || options.above_right) {
                above = $el.DIV('r-label r-above', [options.above, options.required && $el.REQUIRED()]);
                if(options.above_right) {
                    above.classList.add('m-with-right');
                    above.ui_add([$el.S(), options.above_right]);
                }
            }

            this.ui_add([
                above,
                input,
                options.below && $el.DIV('r-label r-below', options.below)
            ]);
        }
    }
}
